import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Footer from "../Footer";
import { toast } from "react-toastify";

import axios from "axios";
import config from "../../function/config";
import Usernav from "../UserHome/Usernav";
import AdminNav from "../Admin/AdminHome/AdminNav";
import HomeNav from "../Navbars/HomeNav";
import NewAdminNav from "../Admin/AdminHome/NewAdminNav";
import NewHomeNav from "../Navbars/NewHomeNav";
import NewFooter from "../NewFooter";

export default function RegisterShipForCharter() {
  const [isScrolled, setIsScrolled] = useState(false);
    const navigate = useNavigate();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50); // Adjust the value to when you want the effect
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const [user, setUser] = useState(null);
  const token = localStorage.getItem("token");
  useEffect(() => {
          if (!token) {
            navigate('/login'); // login page
          }
        }, [token, navigate]);

  useEffect(() => {
    async function fetchdata() {
      try {
        const res2 = await axios.get(
          `${config.base_url}/api/HappyMarineShipping/viewusers`,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Token ${token}`,
            },
          }
        );
        console.log("API response:", res2.data);
        if (res2.data.status === 200) {
          console.log("User:", res2);
          setUser(res2.data.data);
        } else {
          console.log(res2);
        }
      } catch (error) {
        console.log(error);
      }
    }
    fetchdata();
  }, [token]);

  // Scroll to the top
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };



  const [loading, setLoading] = useState(false);
  const [vesselType, setvesselType] = useState("");
  const [YearBuilt, setYearBuilt] = useState("");
  const [DWT, setDWT] = useState("");
  const [Email, setEmail] = useState("");
  const [MobileNO, setMobileNO] = useState("");
  const [BriefDescription, setBriefDescription] = useState("");
  const [OpenArea, setOpenArea] = useState("");
  const [TCVC, setTCVC] = useState("");
  const [Category, setCategory] = useState("");
  const [Subject, setSubject] = useState("");
  const [count, setCount] = useState(0);
  const [selectedImages, setSelectedImages] = useState([]); // Array of { file, preview }
  const [LoadingPort,setLoadingPort] = useState('');
  const [DischargePort,setDischargePort] = useState('');
  const [TypeOfCargo,setTypeOfCargo] = useState('');
  const [CompanyAddress,setCompanyAddress] = useState('');
  const [Company,setCompany] = useState('');
  const [name,setName] = useState('');
  const [Lychan,setLychan] = useState('');
  
const [hoverCountry, setHoverCountry] = useState("");
const [selectedPort, setSelectedPort] = useState("");
const [countryQuery, setCountryQuery] = useState("");



  const [generatedCode, setGeneratedCode] = useState("");

  const normalize = (str) => str.toLowerCase().replace(/[^a-z]/g, "");

  const subCategoryPrefixes = {
    barge: "BRG",
    bulk: "BLK",
    cargo: "CRG",
    container: "CNT",
    fishing: "FIS",
    multipurpose: "MPP",
    passengerferry: "PAX",
    reefer: "REF",
    roro: "ROR",
    tanker: "TNK",
    tugboat: "TUG",
    dredger: "DRG",
    floatingcrane: "FLC",
    landingcraft: "LCT",
    Yacht: "YCT",
    supplyboat: "SUB",
    crewboat: "CRB",
    floatingdock: "FLD",
    other: "OTR",
  };

  useEffect(() => {
    if (vesselType) {
      const normalized = normalize(vesselType);
      const prefix = subCategoryPrefixes[normalized];
      if (prefix) {
        setGeneratedCode(prefix); // ✅ Only set the prefix
      } else {
        setGeneratedCode("");
      }
    }
  }, [vesselType]);

  const userId = localStorage.getItem("userId");

  // NEW state
const [isAdmin, setIsAdmin] = useState(Boolean(user?.is_superuser)); // or pass from props/context
const [otpModalOpen, setOtpModalOpen] = useState(false);
const [otpCode, setOtpCode] = useState("");
const [otpEmail, setOtpEmail] = useState(""); // snapshot of Email when requesting OTP
const [otpSending, setOtpSending] = useState(false);
const [otpVerifying, setOtpVerifying] = useState(false);
const [otpTimer, setOtpTimer] = useState(0); // seconds left to allow resend

// simple 6-digit guard
const isSixDigits = (v) => /^\d{6}$/.test(v);

// countdown for resend button
useEffect(() => {
  if (!otpTimer) return;
  const t = setInterval(() => setOtpTimer((s) => (s > 0 ? s - 1 : 0)), 1000);
  return () => clearInterval(t);
}, [otpTimer]);


const requestEmailOtp = async (email) => {
  setOtpSending(true);
  setLoading(true)
  try {
    await axios.post(`${config.base_url}/api/HappyMarineShipping/auth/send-email-otp/`, { email });
    setOtpEmail(email);
    setOtpModalOpen(true);
    setOtpTimer(60); // 60s cooldown before resend
    toast.success("OTP sent to your email.");
    setLoading(false)
  } catch (err) {
    const msg = err?.response?.data?.message || "Failed to send OTP";
    toast.error(msg);
  } finally {
    setOtpSending(false);
  }
};

const [Url, setUrl] = useState("");


const submitCharterToServer = async (extra = {}) => {
  // your current code, slightly parameterized to pass otp if present
  const yearBuiltClean = String(YearBuilt || "").trim();
  const dwtClean = String(DWT || "").replace(/[, ]+/g, "").trim();

  setLoading(true);
  const formData = new FormData();
  formData.append("vessel_type", vesselType);
  formData.append("user", userId);
  formData.append("tc_vc", TCVC);
  formData.append("url_new", Url);
  formData.append("year_built", yearBuiltClean);
  formData.append(
    "open_area",
    selectedCountry && selectedPort ? `${selectedPort}, ${selectedCountry}` : selectedCountry
  );
  formData.append("DWT", dwtClean);
  formData.append("email", Email);
  formData.append("phone", MobileNO);
  formData.append("brief_description", BriefDescription || "");
  formData.append("name", name || "");
  formData.append("company_address", CompanyAddress || "");
  formData.append("company", Company || "");
  formData.append("ship_code", generatedCode || "");
  formData.append("lychan", Lychan || "");

  // pass verified otp if any
  if (extra?.otp_code) formData.append("otp_code", extra.otp_code);

  try {
    const response = await axios.post(
      `${config.base_url}/api/HappyMarineShipping/RegShipForCharter`,
      formData,
      { headers: { "Content-Type": "multipart/form-data", Authorization: `Token ${token}` } }
    );

    if (response?.data?.status === 200) {
      toast.success("Registered Successfully!", { autoClose: 1500, position: "top-right" });
      setvesselType("");
      setDWT("");
      setEmail("");
      setSelectedImages([]);
      setMobileNO("");
      setOpenArea?.("");
      setYearBuilt("");
      setSelectedCountry("");
      setSelectedPort("");
      setBriefDescription("");
      setTCVC("");
      setName("");
      setCompany("");
      setCompanyAddress("");
      setGeneratedCode("");
      setLychan("");

      navigate("/regShip");
    } else {
      toast.error(response?.data?.message || "Fill the Fields", { autoClose: 1500 });
    }
  } catch (err) {
    const msg = err?.response?.data?.message || err?.message || "Error submitting form";
    toast.error(msg, { autoClose: 2000 });
  } finally {
    setLoading(false);
  }
};






 const handleSubmitCharter = async (e) => {
  e.preventDefault();
  if (user?.is_superuser) {
    // Admins can submit directly
    return submitCharterToServer();
  }

  // Non-admins need email + OTP
  if (!Email?.trim()) {
    return toast.error("Please enter your Email to receive OTP.");
  }
  // 1) Request OTP (opens modal)
  await requestEmailOtp(Email.trim());
};


  const { pathname } = useLocation();
  const [selectedCountry, setSelectedCountry] = useState(null);

 // ---- Countries with ports (sample; extend with your full list) ----
    const countriesWithPorts = {
    "Antigua": {
      flag: "",
      ports: ["St John’s"]
    },
    "Angola": {
      flag: "",
      ports: ["Cabinda", "Futila Terminal", "Lobito", "Luanda", "Mocamedes", "Namibe", "Porto Saco"]
    },
    "Algeria": {
      flag: "",
      ports: ["Algiers", "Annaba", "Arzew", "Arzew El-Djedid", "Bejala", "Bethioua", "Bone", "Mostaganem", "Oran", "Philippeville", "Port Methanier", "Skikda"]
    },
    "Albania": {
      flag: "",
      ports: ["Vlone", "Vlore"]
    },
    "Argentina": {
      flag: "",
      ports: ["Bahia Blanca", "Buenos Aires", "Caleta Cordova", "Caleta Olivares", "Caleta Olivia", "Campana", "Comodoro Rivadavia", "Diamante", "General Lagos", "Ibicuy", "Ingeniero Buitrango", "Ingeniero White", "La Plata", "Puerto Acevedo", "Puerto Belgrano", "Puerto Galvan", "Puerto Ingeniero Rocca", "Puerto Madryn", "Puerto Martins", "Puerto Parana", "Puerto Rosales", "Punta Alvear", "Punta Ancla", "Punta Ciguena", "Punta Loyola", "Ramallo", "Rio Gallegos", "Rosario", "San Lorenzo", "San Martin", "San Nicolas", "San Pedro", "San Sebastian Bay", "Santa Fe", "Villa Constitucion", "Zarate"]
    },
    "Ascension Island": {
      flag: "",
      ports: ["Clarence Bay", "English Bay", "Georgetown"]
    },
    "Aruba": {
      flag: "",
      ports: ["Barcadera", "Oranjestad", "San Nicolas"]
    },
    "Australia": {
      flag: "",
      ports: ["Abbot Point", "Adelaide", "Albany", "Ball’s Head", "Ballast Point", "Balmain", "Barney Point", "Barrow Island", "Beauty Point Harbour", "Bell Bay", "Berry’s Bay", "Blackwattle Bay", "Boston Bay", "Botany Bay", "Bowen", "Brisbane", "Bunbury", "Bundaberg", "Burnie", "Cairns", "Carnarvon", "Cooktown", "Cossack Pioneer Terminal", "Crib Point", "Dalrymple Bay", "Dampier", "Darling Harbour", "Darwin", "Devonport", "East Intercourse Island", "Eden", "Emu Bay", "Esperance", "Finucane Island", "Fisherman Islands", "Fremantle", "Geelong", "George Town", "Geraldton", "Gladstone", "Glebe Island", "Gore Bay", "Gove", "Groote Eylandt", "Hastings", "Hay Point", "Hobart", "Humbug Point", "Koolan Island", "Kurnell", "Kwinana", "Launceston", "Long Island Point", "Long Reach", "Lorim Point", "Mackay", "Macquarie Point", "Melbourne", "Miner Bay", "Mistaken Island", "Munganno Point", "Nelson Point", "Newcastle", "Parker Point", "Perth", "Pinkenba", "Port Alma", "Port Augusta", "Port Botany", "Port Hedland", "Port Jackson", "Port Kembla", "Port Kennedy", "Port Latta", "Port Lincoln", "Port Pirie", "Port Stanvac", "Port Walcott", "Porter Bay", "Portland", "Princess Royal Harbour", "Proper Bay", "Pyrmont", "Risdon", "Rockhampton", "Self’s Point", "Snail’s Bay", "Snug Cove", "Spalding Cove", "Stanley", "Sydney", "Sydney Cove", "Thursday Island", "Townsville", "Trial Bay", "Twofold Bay", "Urangan", "Wallaroo", "Weipa", "Western Port", "White Bay", "Whyalla", "Withnell Bay", "Wyndham", "Yampi Sound"]
    },
    "Bahamas": {
      flag: "",
      ports: ["Clifton Point", "Freeport", "Nassau"]
    },
    "Bahrain": {
      flag: "",
      ports: ["Mina Salman", "Sitra"]
    },
    "Bangladesh": {
      flag: "",
      ports: ["Chalna", "Chittagong", "Khulna", "Mongla"]
    },
    "Barbados": {
      flag: "",
      ports: ["Black Rock Tanker Terminal", "Bridgetown", "Needham’s Point Tanker Terminal", "Olistins Bay Tanker Terminal", "Spring Garden Tanker Terminal"]
    },
    "Belgium": {
      flag: "",
      ports: ["Antwerp", "Bruges", "Ghent", "Ostend", "Zeebrugge"]
    },
    "Belize": {
      flag: "",
      ports: ["Belize City"]
    },
    "Benin": {
      flag: "",
      ports: ["Cotonou"]
    },
    "Bermuda": {
      flag: "",
      ports: ["Freeport", "Hamilton"]
    },
    "Azores": {
      flag: "",
      ports: ["Horta", "Ponta Delgada"]
    },
    "Brazil": {
      flag: "",
      ports: ["Admiral Barroso Terminal", "Alemoa Terminal", "Antonina", "Aracaju", "Aratu", "Barao De Tefe", "Barnabe Island Terminal", "Belem", "Butadeine Dock Island", "Cabedelo", "Conceicaoziinha Terminal", "Cosipa Terminal", "Cutrale Terminal", "DTSE/GEGUA Oil Terminal", "Fortaleza", "Governor’s Island", "Ilha Redonda", "Itaqui", "Maceio", "Madre Deus", "Manaus", "Miramar Oil Terminal", "Mucuripe", "Natal", "Niteroi", "Paranagua", "Ponta da Madeira", "Porto Alegre", "Praia Mole", "Recife", "Redonda Island", "Rio de Janeiro", "Rio Grande", "Salvador", "Santos", "Sao Cristovao", "Sao Luis", "Sao Sebastiao", "Torgua", "Tramandai", "Tubarao", "Ultrafertil Terminal", "Vitoria"]
    },
    "Cameroon Republic": {
      flag: "",
      ports: ["Bonaberi", "Douala", "Limbe", "Limboh Terminal", "Victoria"]
    },
    "Bulgaria": {
      flag: "",
      ports: ["Bourgas", "Pomorie", "Sozopol", "Tzarevo", "Varna"]
    },
    "Brunei Darussalam": {
      flag: "",
      ports: ["Kuala Belait", "Seria"]
    },
    "Canada": {
      flag: "",
      ports: ["Argentia", "Baie Verte", "Baie-Comeau", "Bathurst", "Bayside", "Belledune", "Berrypoint", "Botwood", "Brooklyn", "Burlington Bay", "Campbell River", "Canaport", "Chandler", "Charlottetown", "Chatham", "Chicoutimi", "Churchill", "Clarenville", "Clarkson", "Come By Chance", "Comeau Bay", "Corner Brook", "Dalhousie", "Duke Point", "Duncan Bay", "Esquimalt", "Fairview Cove", "Frobisher", "Gold River", "Goose Bay", "Halifax", "Hamilton", "Havre St Pierre", "Holyrood", "Humbermouth", "Iqaluit", "Kingston", "Kingsville", "Kitimat", "Lewisporte", "Liverpool", "Long Harbour", "Matane", "McKellar Island", "Middle Point", "Mission River", "Mont Louis", "Montreal", "Mulgrave", "Nanaimo", "New Glasgow & Trenton", "New Richmond", "Newcastle", "North Sydney", "Ocean Falls", "Ogden Point", "Pictou", "Point Tupper", "Pointe Aux Basques", "Pointe Noire", "Port Alberni", "Port Alfred", "Port Alice", "Port aux Basques", "Port Cartier", "Port Harmon", "Port Hawkesbury", "Port Medway", "Port Saguenay", "Port Stanley", "Powell River", "Prince Rupert", "Quebec", "Ridley Island", "Rimouski", "Roberts Bank", "Saint John", "Sarnia", "Sept-Iles", "Seven Islands", "Shelburne", "Sorel", "St Andrews", "St John’s", "St Romuald", "Stephenville", "Stewart", "Sydney", "Tahsis", "Thunder Bay", "Toronto", "Trois-Rivieres", "Vancouver", "Victoria", "Whiffen Head", "Windsor", "Yarmouth"]
    },
    "Cayman Islands": {
      flag: "",
      ports: ["Georgetown"]
    },
    "Cape Verde Islands": {
      flag: "",
      ports: ["Mindelo", "Palmeira Bay", "Pedra De Lume", "Porto Grande", "Sal Island", "Santa Maria Bay"]
    },
    "Canary Islands": {
      flag: "",
      ports: ["Las Palmas", "Puerto Caballo Oil Terminal", "Puerto de la Hondura Oil Terminal", "Puerto de La Luz y Las Palmas", "Santa Cruz de Tenerife"]
    },
    "Chile": {
      flag: "",
      ports: ["Antofagasta", "Arica", "Barquito", "Cabo Negro", "Calbuco", "Caldera", "Caleta Clarencia", "Caleta Coloso", "Caleta Ossa", "ChanaraI", "Coquimbo", "Corrale", "Cutter Cove", "Gregorio", "Guacolda", "Guayacan", "Huasco", "Iquique", "La Chimba Cove", "Laredo", "Las Losas", "Las Salinas", "Lendaura", "Lirquen", "Pecket", "Porvenir", "Puerto Coralle", "Puerto Corral", "Puerto Montt", "Puerto Percy", "Puerto Ventanas", "Punta Arenas", "Quintero", "San Antonio", "San Gregorio", "San Vicente", "Santa Barbara", "Talcahuano", "Taltal", "Tocopilla", "Valdivia", "Valparaiso"]
    },
    "China": {
      flag: "",
      ports: ["Amoy", "Baoshan", "Bayuquan", "Beijang", "Canton", "Chefoo", "Chinwangtao", "Dagang", "Dairen", "Dalian", "Dayao Bay", "Dongdu", "Fuzhou", "Foochow", "Ganjingzi", "Guangzhou", "Handi", "Hankow", "Heizluzui", "Heshangdao", "Hong Kong", "Huangdao", "Huangpu", "Nanjing", "Nianyuwan", "Qianwan", "Qingdao", "Qinhuangdao", "Shanghai", "Shantou", "Siergou", "Swatow", "Taku Bar", "Tanggu", "Tianjin", "Tsamkong", "Tsingtao", "Wei Hai", "Wuhan", "Xiahai", "Xiamen", "Xianglujiao", "Xidi", "Xigang", "Xingang", "Xinshenwei", "Yantai", "Yingkou", "Zhanjiang"]
    },
    "Cocos Islands": {
      flag: "",
      ports: ["Port Refuge"]
    },
    "Christmas Island": {
      flag: "",
      ports: ["Christmas Island"]
    },
    "Colombia": {
      flag: "",
      ports: ["Barranquilla", "Buenaventura", "Cartagena", "Cienaga", "Covenas Offshore Terminal", "Ecopetrol", "Mamonal", "Monomeros", "Muelles El Bosque", "Pindo", "Pozos Colorados", "Puerto Prodeco", "Puerto Zuniga", "Santa Marta", "Tolu", "Tumaco"]
    },
    "Costa Rica": {
      flag: "",
      ports: ["Golfito", "Golfo Dulce", "Puerto Limon", "Puerto Moin", "Puntarenas", "Quepos"]
    },
    "Congo (Democratic Republic)": {
      flag: "",
      ports: ["Ango-Ango", "Banana", "Boma", "Matadi", "Moanda Oil Terminal"]
    },
    "Congo (Republic of Congo)": {
      flag: "",
      ports: ["Pointe-Noire"]
    },
    "Comoros": {
      flag: "",
      ports: ["Dzaoudzi", "Longoni", "Mamoudzou", "Mayotte", "Moroni", "Pamandzi Bay"]
    },
    "Croatia": {
      flag: "",
      ports: ["Bakar", "Dubrovnik", "Gazenica", "Krk Island", "Luka Gruz", "Omisalj", "Pula", "Rijeka", "Rijeka Dubrovačka", "Sepen", "Sibenik", "Split", "Srećica", "Susak", "Urinj", "Zadar"]
    },
    "Cuba": {
      flag: "",
      ports: ["Antilla", "Banes", "Caibarien", "Cardenas", "Casilda", "Cayo Frances", "Cienfuegos", "Felton", "Guantanamo", "Havana", "Macabi", "Manzanillo", "Mariel", "Matanzas", "Nuevitas", "Pastellilo", "Preston", "Puerto Padre", "Puerto Tarafa", "Santiago de Cuba", "Tarafa"]
    },
    "Cyprus": {
      flag: "",
      ports: ["Akrotiri", "Dhekelia", "Famagusta", "Gemikonagi", "Karavostassi", "Larnaca", "Limassol", "Moni", "Morphou Bay", "Paphos", "Vassiliko", "Xeros"]
    },
    "Denmark": {
      flag: "",
      ports: ["Aabenraa", "Aalborg", "Aarhus", "Asnaesvaerkets Havn", "Avernakke", "Copenhagen", "Ebeltoft", "Elsinore", "Ensted", "Esbjerg", "Fredericia", "Frederikshavn", "Frederikssund", "Gulfhavn", "Helsingor", "Horsens", "Kalundborg", "Karrebaeksminde", "Koge", "Kolding", "Korsoer", "Kyndby", "Lindholm", "Lindoe Terminal", "Lyngs Odde", "Masnedsvaerkets Havn", "Naestved", "Nyborg", "Odense", "Orehoevd", "Ronne", "Rudkobing", "Skaelskor", "Skaerbaek", "Skagen", "Stigsnaesvaerkets Havn", "Svendborg", "Tuborg", "Vordingborg"]
    },
    "Ecuador": {
      flag: "",
      ports: ["Andiport", "Balao Terminal", "Esmeraldas", "Guayaquil", "La Libertad", "Terpe Terminal"]
    },
    "Dominican Republic": {
      flag: "",
      ports: ["Barahona", "Cabo Rojo", "Ciudad Trujillo", "La Romana", "Manzanillo", "San Pedro de Macoris", "Sans Souci", "Santo Domingo"]
    },
    "Dominica": {
      flag: "",
      ports: ["Roseau", "Woodbridge Bay"]
    },
    "Djibouti": {
      flag: "",
      ports: ["Djibouti"]
    },
    "Egypt": {
      flag: "",
      ports: ["Abu Zenima", "Adabiya", "Alexandria", "Ataqa", "El Alamein", "El Dekheila", "El Meks", "Hurghada", "Kosseir", "Mersa el Hamra", "Port Ibrahim", "Port Said", "Port Tewfik", "Quseir", "Ras Budran", "Ras Gharib", "Ras Shukheir", "Ras Sudr", "Safaga", "Suez", "Wadi Feiran"]
    },
    "Fiji": {
      flag: "",
      ports: ["Lautoka", "Suva", "Walu Bay"]
    },
    "Faroe Islands": {
      flag: "",
      ports: ["Drelnes", "Fuglafjordur", "Klaksvik", "Kollafjordur", "Midvaag", "Runavik", "Skaala", "Soervaag", "Strendur", "Torshavn", "Trangisvaag", "Tvoroyri", "Vagu", "Vestmanna"]
    },
    "Falkland Islands": {
      flag: "",
      ports: ["Port Stanley", "Stanley"]
    },
    "Estonia": {
      flag: "",
      ports: ["Kesklinna", "Kopli-Port Of Tallinn", "Muuga-Port Of Tallinn", "Novotalinsky", "Old City Harbour-Port of Tallinn", "Paldiski-Port Of Tallinn", "Paljassaare", "Tallinn"]
    },
    "Eritrea": {
      flag: "",
      ports: ["Assab", "Massawa"]
    },
    "Equatorial Guinea": {
      flag: "",
      ports: ["Malabo", "Punta Europa Terminal", "Rey Malabo"]
    },
    "El Salvador": {
      flag: "",
      ports: ["Acajutla", "Acajutla Offshore Terminal", "Cutuco", "La Union"]
    },
    "Finland": {
      flag: "",
      ports: ["Abo", "Ajos", "Haakoninlahti", "Hamina", "Hanko", "Haponniemi", "Helsinki", "Hepokari", "Inkoo", "Jakobstad", "Kemi", "Kokkola", "Kotka", "Kristinestad", "Laajasalo Oil Harbour", "Loviisa", "Mantyluoto", "Naantali", "Nuottasaari", "Oritkari", "Oulu", "Pansio", "Pateniemi", "Pietarsaari", "Pori", "Porvoo", "Rauma", "Reposaari", "Tolkkinen-Tolkis", "Toppila", "Turku", "Uusikaupunki", "Veitsiluoto", "Vihreasaari", "Vuosaari Harbour", "Ykspihlaja"]
    },
    "France": {
      flag: "",
      ports: ["Ajaccio", "Ambes", "Antibes", "Antifer", "Basse Indre", "Bassens", "Bastia", "Bayonne", "Bec d’ Ambes", "Blaye", "Bordeaux", "Boulogne-sur-Mer", "Brest", "Caen", "Calais", "Cannes", "Caronte", "Cherbourg", "Cordemais", "Corniguel", "Coueron", "Dieppe", "Donges", "Dunkirk", "Etang de Berre", "Fos", "Gravenchon", "Haut Indre", "Honfleur", "Indret", "La Ciotat", "La Mede", "La Nouvelle", "La Pallice", "La Pointe de Berre", "La Rochelle", "La Rochelle-Pallice", "La Seyne-Bregaillon", "Lavera", "Le Havre", "Le Verdon", "Lorient", "Marseilles", "Montoir", "Nantes-St Nazaire", "Nice", "Paimboeuf", "Pauillac", "Petit Couronne", "Port de Bouc", "Port Jerome", "Port St Louis du Rhone", "Port St Nicholas", "Port Toga", "Port Tudy", "Quimper-Corniguel", "Rouen", "Sete", "St Malo", "St Nazaire", "Toulon La Seyne", "Villefranche"]
    },
    "Georgia": {
      flag: "",
      ports: ["Batumi", "Poti"]
    },
    "Gambia": {
      flag: "",
      ports: ["Banjul"]
    },
    "Gabon": {
      flag: "",
      ports: ["Gamba", "Libreville", "Ovendo", "Owendo", "Port Gentil"]
    },
    "French Polynesia": {
      flag: "",
      ports: ["Papeete"]
    },
    "Germany": {
      flag: "",
      ports: ["Blexen", "Brake", "Bremen", "Bremerhaven", "Brunsbuttel", "Butzfleth", "Cuxhaven", "Elbeharbour", "Elsfleth", "Emden", "Flensburg", "Hamburg", "Holtenau", "Kiel", "Kiel-Holtenau", "Laboe", "Lubeck", "Nordenham", "Ostermoor", "Rostock"]
    },
    "Gibraltar": { flag: "", ports: ["Gibraltar"] },
  "Ghana": { flag: "", ports: ["Takoradi", "Tema"] },
  "Greece": { flag: "", ports: [
    "Acandia","Adamas","Aghios Nikolaos","Agia Marina","Agia Trias","Agioi Theodoroi","Argostoli",
    "Aspraspitia Ore Terminal","Aspropyrgos","Ayia Marina","Ayios Nikolaos","Canea","Cephalonia",
    "Corfu (Kerikra)","Corinth","Corinth Canal","Drapetsona Bay","Elefsis","Eleusis","Foron Bay",
    "Gera Bay","Hercules Port","Iraklion","Isthmia","Kalamaki","Kalamata","Kali Limenes","Kavala",
    "Kithira","Kos","Lamia","Leros Island","Lixouri","Malagari","Mandraki","Mandukio","Marathocampos",
    "Megara Oil Terminal","Microlimano","Milos Island","Mitilene","Nafplion","Nauplia","Pachi","Pamfila",
    "Paroikia","Paros","Patras","Perama","Phaleron Bay","Piraeus","Poseidonia","Prinos","Pylos",
    "Pythagorio","Rhodes","Rion","Salonica","Samos","Skaramanga","Souda Bay","St George Harbour",
    "Stylis","Suda Bay","Syros Island","Thessaloniki","Volos","Voudhia Bay","Zakinthos","Zante","Zea"
  ]},
  "Guyana": { flag: "", ports: ["Georgetown"] },
  "Guinea-Bissau": { flag: "", ports: ["Bissau"] },
  "Guinea": { flag: "", ports: ["Conakry"] },
  "Guatemala": { flag: "", ports: ["Puerto Barrios","Puerto Quetzal","San Jose","Santo Tomas de Castilla"] },
  "Guam": { flag: "", ports: ["Apra Harbour"] },
  "Guadeloupe": { flag: "", ports: ["Pointe-a-Pitre"] },
  "Grenada": { flag: "", ports: ["Grand Mal Tanker Terminal","Queen’s Park Tanker Terminal","St George’s"] },
  "Greenland": { flag: "", ports: [
    "Faeringehavn","Godthaab","Grønnedal","Ivigtut","Kangerlussuaq","Kangilinnguit",
    "Narsarsuaq","Nuuk","Qaanaaq","Soendre Strømfjord"
  ]},
  "Honduras": { flag: "", ports: ["La Ceiba","Tela"] },
  "Haiti": { flag: "", ports: ["Port au Prince"] },
  "Hong Kong": { flag: "", ports: [
    "Chai Wan","Hong Kong","Kowloon","Kwai Chung","Kwun Tong","Lamma Island","Stonecutters Island",
    "Tap Shek Kok","Tsing Yi Island","Tsuen Wan","Tuen Mun","Wan Chai","Yau Ma Tei"
  ]},
  "Iceland": { flag: "", ports: [
    "Grundartangi","Hafnarfjordur","Keflavik - Njarovik","Njarovik","Reykjavik","Seydisfjordur","Straumsvik"
  ]},
  "India": { flag: "", ports: [
    "Beypore","Bheemunipatnam","Bombay","Budge Budge","Calcutta","Calicut","Cannanore","Chennai","Cochin",
    "Jawahar Dweep","Kakinada","Kandia","Kochi","Kolkata","Madras","Mangalore","Mormugao","Mumbai",
    "New Mangalore","Okha","Panaji","Pir Pau","Pondicherry","Port Blair","Port Okha","Tellicherry",
    "Visakhapatnam","Vizag"
  ]},
  "Indonesia": { flag: "", ports: [
    "Ambon","Ampeanam","Balikpapan","Batu Ampar","Belawan","Bengkulu","Benoa","Biak","Buatan","Bunyu","Cigading",
    "Cilacap","Cirebon","Citra Ujung Baru","Dumai","Gabion","Gresik","Jakarta","Jambi","Kabil","Kalianget",
    "Kota Baru","Kupang","Labuantring","Lembar","Macassar","Makassar","Manado","Medan","Muntok",
    "North Pulau Laut Coal Terminal","Palembang","Pangkalan Susu","Panjang","Pare Pare","Pekanbaru","Plaju & Sungai Gerong",
    "Pontianak","Pulau Laut","Pulau Sambu","Sabang","Samarinda","Sekupang","Semarang","Sibolga","Sorong",
    "Sunda Kelapa","Sungai Gerong","Sungai Pakning","Surabaya","Tanjung Emas","Tanjung Intan","Tanjung Pandan",
    "Tanjung Perak","Tanjung Priok","Tanjung Uban","Tarahan Terminal","Tarakan Island","Telok Ayer","Teluk Bayur","Ujung Pandang"
  ]},
  "Iran": { flag: "", ports: [
    "Abadan","Bahregan","Bahregan Oil Centre (BOC)","Bahrgan","Bandar Abbas","Bandar Imam Khomeini",
    "Bandar Mahshahr","Bandar Shahid Bahonar","Bandar Shahid Rejaie","Barkan","Bushehr","Bushire",
    "Cyrus Terminal","Kharg Island","Khemco Terminal","Lavan Island","Shahid Bahonar","Shahid Rajai","Soroosh Terminal"
  ]},
  "Iraq": { flag: "", ports: [
    "Abu Al Kashib","Abu Flus","Ashar","Basrah","Fao","Khor Al Amaya","Khor Al Zubair","Maqal","Sunger"
  ]},
  "Ireland": { flag: "", ports: [
    "Aughinish","Bantry","Castletown Bere","Cobh","Cork","Dinish Island","Drogheda","Dublin","Dun Laoghaire","Duncannon",
    "Foynes","Galway","Haulbowline","Howth","Kilrush","Leahlill Quarry","Limerick","Moneypoint","Rathmullen","Ringaskiddy",
    "Rosslare Europort","Rushbrooke","Shannon Foynes Port","Sligo","Tarbert Island","Waterford","Whiddy Island","Whitegate"
  ]},
  "Israel": { flag: "", ports: ["Ashdod","Ashkelon","Eilat","Haifa","Kishon Zone"] },
  "Isle of Man": { flag: "", ports: ["Douglas"] },
  "Italy": { flag: "", ports: [
    "Ancona","Arbatax","Assemini","Augusta","Bagnoli","Bala","Bari","Brindisi","Cagliari","Castellammare di Stabia",
    "Catania","Civitavecchia","Crotone","Falconara","Fiumicino","Formia","Gaeta","Gela","Genoa",
    "La Maddalena (Cagliari)","La Maddalena (Sardinia)","La Spezia","Leghorn","Livorno","Melilli Oil Terminal","Messina",
    "Milazzo","Monfalcone","Monopoli","Naples","Ortona","Otranto","Palau","Palermo","Portici","Porto Corsini",
    "Porto di Malamocco","Porto Empedocle","Porto Foxi","Porto Marghera","Porto Marmoreo","Porto San Leonardo","Porto Santo Stefano",
    "Porto Torres","Pozzuoli","Priolo","Priolo Gargallo","Punto Franco","Quiliano Terminal","Ravenna","Reggio Calabria",
    "San Vitale","Santa Panagia Bay","Sarroch","Savona-Vado","Siracusa","Talamone","Taranto","Termini Imerese",
    "Torre Annunziata","Torre del Greco","Trapani","Trieste","Vado Ligure","Venice"
  ]},
  "Jamaica": { flag: "", ports: ["Kingston","Port Bustamente","Port Esquivel","Port Royal","Salt River"] },
  "Ivory Coast": { flag: "", ports: [
    "Abidjan","Banco Bay","Canal de Virdi","Locodjo","Port Bouet Tanker Terminal"
  ]},
  "Japan": { flag: "", ports: [
    "Aboshi","Aburakawa","Aioi","Amagasaki","Aomori","Chiba","Chita","Etajima","Fukuyama","Funakawa","Hakata","Hakodate",
    "Hamada","Hannan","Hashihama","Heianza","Hibikinada","Higashi-Harima","Higashi-Ogishima","Hikari","Hikoshima","Himeji",
    "Hiro","Hirohata","Hiroshima","Iho","Imabari","Imari","Ishikara","Iwakuni","Izumisano","Kagoshima","Kainan","Kakogawa",
    "Kanmon Ko","Kanokawa","Karita","Kashima","Kawasaki","Keihin","Kikuma","Kinwan","Kishiwada","Kitakyushu","Kobe","Kokura",
    "Kudamatsu","Kure","Kushiro","Marugame","Mategata","Matsuyama","Mega","Miike","Mitsukojima","Mizushima","Moji","Muroran",
    "Nagasaki","Nagoya","Naha","Namikata","Niigata-Higashi","Niigata-Nishi","Nishihara","Ofunato","Ogishima","Oita","Omishima",
    "Onoda","Osaka","Owase","Rokko Island","Sakai","Sakaide","Sakaiminato","Sasebo","Senboku","Shikama","Shimizu","Shimonoseki",
    "Shimotsu","Shirashima","Susaki","Takasago","Takehara","Tamashima","Tobata","Tokai","Tokuyama","Tonda","Tokyo","Toyama",
    "Toyama-Shinko","Tsuruga","Ube","Ukishima","Wakamatsu","Wakayama","Yawata","Yokkaichi","Yokohama","Yokosuka"
  ]},
  "Kenya": { flag: "", ports: [
    "Kilindi","Kipevu Oil Terminal","Mbaraki","Mombasa","Port Reitz","Port Tudor","Shimanzi Oil Terminal"
  ]},
  "Jordan": { flag: "", ports: ["Aqaba","Mo’ta","Mushterak"] },
  "Kiribati": { flag: "", ports: ["Banaba"] },
  "North Korea": { flag: "", ports: ["Hungnam"] },
  "South Korea": { flag: "", ports: ["Busan","Inchon","Pohang","Pusan","Samil","Yeosu","Yosu"] },
  "Kuwait": { flag: "", ports: ["Mina Abdulla","Mina Al Ahmadi","Mina Al Zour","Mina Saud","Shuaiba","Shuwaikh"] },
  "Latvia": { flag: "", ports: ["Lielupe","Liepaja","Riga","Ventspils"] },
  "Lebanon": { flag: "", ports: ["Beirut","Dora Terminal","Saida","Sidon","Tripoli","Zahrani Terminal"] },
  "Liberia": { flag: "", ports: ["Buchanan","Monrovia"] },
  "Libya": { flag: "", ports: [
    "Benghazi","Es Sider","Marsa al Hariga","Marsa El Brega","Ras Lanuf","Rasco Harbour","Sirtica Terminal","Tarabulus",
    "Tobruk","Tripoli","Zueitina"
  ]},
  "Madeira": { flag: "", ports: ["Funchal","Praia Formosa"] },
  "Madagascar": { flag: "", ports: [
    "Andoany","Antalaha","Antsiranana","Diego Suarez","Fort Dauphin","Mahajanga","Majunga","Manakara","Mananjary","Morondava",
    "Nosy Be","Tamatave","Toamasina","Tolanaro","Tulear"
  ]},
  "Maldives": { flag: "", ports: ["Male"] },
  "Lithuania": { flag: "", ports: ["Klaipeda"] },
  "Malaysia": { flag: "", ports: [
    "Biawak","Butterworth","Datuk Sim Kheng Hong","Johor","Kota Kinabalu","Kuala Baram","Kuching","Labuan","Lutong","Malacca",
    "Miri","Pasir Gudang","Penang","Pending","Port Dickson","Port Kelang","Port Swettenham","Prai","Sandakan","Sejingkat","Senari",
    "Sibu","Sungai Udang","Tanah Puteh","Tanjung Bruas","Tanjung Manis","Tawau","Teluk Anson","Westport"
  ]},
  "Mauritius": { flag: "", ports: ["Port Louis"] },
  "Mauritania": { flag: "", ports: ["Nouadhibou","Nouakchott","Point Central","Port de L'Amitie","Port Eltenne"] },
  "Martinique": { flag: "", ports: ["Fort-de-France"] },
  "Malta": { flag: "", ports: ["Marsaxlokk","Valletta"] },
  "Mexico": { flag: "", ports: [
    "Cedros Island","Coatzacoalcos","Ensenada","Guaymas","Manzanillo","Mazatlan","Minatitlan","Morro Redondo","Nanchital",
    "Pajaritos","Rosarito Terminal","Salina Cruz","San Pedrito Port","Tampico","Tuxpan","Veracruz"
  ]},
  "Myanmar": { flag: "", ports: ["Akyab","Bassein","Moulmein","Mawlamyine","Pathein","Rangoon","Sittwe","Yangon"] },
  "Mozambique": { flag: "", ports: ["Beira","Maputo","Matola","Mozambique Island","Nacala","Pemba","Quelimane"] },
  "Morocco": { flag: "", ports: [
    "Agadir","Al Hoceima","Casablanca","Kenitra","Mohammedia","Port de Fedala","Port Nador","Safi","Tangier"
  ]},
  "Monaco": { flag: "", ports: ["Monaco"] },
  "Micronesia": { flag: "", ports: ["Tomil Harbour","Yap Colonia International Port"] },
  "Nauru": { flag: "", ports: ["Nauru"] },
  "Namibia": { flag: "", ports: ["Walvis Bay"] },
  "Netherlands": { flag: "", ports: [
    "Amsterdam","Axel Plain","Beverwijk","Botlek","Braakman Harbour","Delfzijl","Den Helder","Dordrecht","Europoort","Flushing",
    "Hansweert","Hoek van Holland","Hook of Holland","IJmuiden","Maassluis","Maasvlakte","Middelburg","Moerdijk","Pernis",
    "Port Scaldia","Rotterdam","Rozenburg","Sas Van Gent","Schiedam","Terneuzen","Velsen","Vlaardingen","Vlissingen","Ymuiden",
    "Zaandam","Zaanstad"
  ]},
  "New Caledonia": { flag: "", ports: ["Baie de Numbo","Baie des Dames","Kouaoua","Noumea","Poro","Thio"] },
  "Netherlands Antilles": { flag: "", ports: [
    "Bullen Bay","Caracas Bay","Emmastad","Santa Anna Bay","Schottegat","Sint Michielsbay","St Michel’s Bay","Willemstad"
  ]},
  "New Zealand": { flag: "", ports: [
    "Auckland","Bluff","Christchurch","Dunedin","Eastland Port","Gisborne","Lyttelton","Marsden Point","Napier","Nelson",
    "New Plymouth","Otago Harbour","Picton","Port Chalmers","Port Marlborough","Port Taranaki","Ravensbourne","Tauranga",
    "Timaru","Wanganui","Wellington","Whangarei"
  ]},
  "Nigeria": { flag: "", ports: [
    "Apapa","Bonny Inshore Terminal","Calabar","Dawes Island","Dockyard Creek","Escravos Oil Terminal","Forcados Oil Terminal","Ibeto",
    "Lagos","Okrika","Pennington","Port Harcourt","Qua Iboe"
  ]},
  "Nicaragua": { flag: "", ports: ["Corinto","Puerto Sandino"] },
  "Norway": { flag: "", ports: [
    "Aalesund","Aker Base","Ardalstangen","Arendal","Bergen","Bodo","Borg Havn IKS","Breivik","Brevik","Drammen","Egersund",
    "Fagerstrand","Fiborgtangen","Fredrikstad","Gismervoy","Grenland Harbour","Grimstad","Haavik","Halden","Hammerfest","Harstad",
    "Haugesund","Heroya","Holmen","Homsvik","Honningsvag","Horten","Hoyanger","Husnes","Kambo","Kirkenes","Kleven","Kristiansand",
    "Kristiansund","Langesund","Larvik","Mandal","Melios Harbour","Mjaanesholmen","Mo I Rana","Moss","Naersnes","Narvik",
    "Orkanger","Oslo","Porsgrunn","Prostneset","Rafnes","Risavika","Sandefjord","Sandnes","Sarpsborg","Sjursoya","Skien","Skogn",
    "Slagen","Sola","Stavanger","Svartnes","Svelvik","Svolvaer","Tananger","Tangen","Thamshavn","Tonsberg","Tromsdalen","Tromso",
    "Trondheim","Vardo"
  ]},
  "Papua New Guinea": { flag: "", ports: ["Lae","Lorengau","Madang","Port Moresby","Rabaul"] },
  "Panama": { flag: "", ports: [
    "Almirante","Bahia Las Minas","Balboa","Coco Solo North","Colon","Cristobal","Las Minas Bay","Manzanillo International Terminal",
    "Rodman Naval Station"
  ]},
  "Pakistan": { flag: "", ports: ["Juna Bunder","Karachi"] },
  "Oman": { flag: "", ports: ["Mina al Fahal","Muscat","Port Sultan Qaboos"] },
  "Peru": { flag: "", ports: [
    "Cabo Blanco","Callao","Chimbote","Coishco","General San Martín","Ilo","La Pampilla","Lobitos","Matarani","Mollendo","Pacasmayo",
    "Paramonga","Pimentel","Pisco","Salaverry","San Nicolas","Supe","Talara"
  ]},
  "Philippines": { flag: "", ports: [
    "Bais","Bataan","Batangas","Cebu","Culasi","Davao","Dumaguit","Estancia","Hondagua","Iloilo","Jolo","Jordan","Lamao","Legaspi",
    "Limay","Lucanin","Manila","Mariveles","Masbate","Mati","Olongapo","Poro Point","Roxas City","San Fernando","San Jose","Sangi",
    "Santa Ana","Sasa","Subic Bay","Toledo (Philippines)","Villanueva","Zamboanga"
  ]},
  "Puerto Rico": { flag: "", ports: [
    "Guanica","Guayanilla","Las Mareas","Mayaguez","Ponce","Porto Nuevo","San Juan","Tallaboa"
  ]},
  "Portugal": { flag: "", ports: ["Douro","Faro & Olhao","Leixoes","Lisbon","Oporto","Santa Apolonia","Setubal"] },
  "Poland": { flag: "", ports: ["Gdansk","Gdynia","Port Polnocny","Swinoujscie","Szczecin"] },
  "Qatar": { flag: "", ports: ["Doha","Halul Island","Mesaieed","Umm Said"] },
  "Romania": { flag: "", ports: ["Constantza","Galatz"] },
  "Reunion": { flag: "", ports: ["Pointe des Galets"] },
  "Russia": { flag: "", ports: [
    "Archangel","Bakaritsa","Ekonomiya","Kaliningrad","Kandalaksha","Leningrad","Leviy Bereg","Lomonosov","Murmansk",
    "Novorossiysk","Sheskharis","St Petersburg","Taganrog","Tuapse","Vladivostok","Vyborg","Yelsk","Yeysk"
  ]},
  "South Africa": { flag: "", ports: [
    "Cape Town","Durban","East London","Mossel Bay","Port Elizabeth","Port Natal","Saldanha Bay","Simonstown"
  ]},
  "Somalia": { flag: "", ports: ["Berbera","Chisimalo","Kismayu","Mogadiscio"] },
  "Solomon Islands": { flag: "", ports: ["Honiara","Point Cruz"] },
  "Slovenia": { flag: "", ports: ["Izola","Koper","Piran"] },
  "Singapore": { flag: "", ports: [
    "Brani Terminal","Jurong","Keppel","Pasir Panjang","Pulau Ayer Chawan","Pulau Bukom","Pulau Merlimau","Pulau Pesek",
    "Pulau Sebarok","Sembawang","Singapore","Tanjong Pagar"
  ]},
  "Sierra Leone": { flag: "", ports: ["Freetown","Kissy Oil Terminal","Pepel"] },
  "Seychelles": { flag: "", ports: ["Mahe","Port Victoria"] },
  "Serbia & Montenegro": { flag: "", ports: ["Bar","Kotor","Lipci"] },
  "Senegal": { flag: "", ports: ["Dakar","M’Bao Oil Terminal"] },
  "Saudi Arabia": { flag: "", ports: ["Jeddah","Ju’aymah Crude & LPG Terminals","Ras al Khafji","Ras Tanura","Yanbu"] },
  "São Tomé and Príncipe": { flag: "", ports: ["Santo Antonio","Sao Tome"] },
  "Samoa": { flag: "", ports: ["Apia"] },
  "Spain": { flag: "", ports: [
    "Abra","Algeciras","Alicante","Almeria","Aviles","Barcelona","Bilbao","Burriana","Cadiz","Cala Figuera","Cartagena","Castellon",
    "Castro-Urdiales","Ceuta","Corcubion","Corunna (La Coruña)","Escombreras","Ferrol","Gijon","Huelva","La Coruna","Mahon","Malaga",
    "Melilla","Palma","Pasajes","Puerto De Santa Maria","Puerto Real","Puerto Santa Maria","Punta Ceballos Tanker Terminal",
    "Punta Lucero Tanker Terminal","Raos","Rota","San Esteban de Pravia","San Sebastian","Santander","Santurce","Seville","Tarragona",
    "Torrevieja","Valencia","Vigo","Zorroza"
  ]},
  "Suriname": { flag: "", ports: ["Paramaribo"] },
  "Sudan": { flag: "", ports: ["Marsa Bashayer Export Terminal","Port Sudan","Suakin"] },
  "St. Vincent": { flag: "", ports: ["Arnos Vale","Campden Park Bay","Kingstown"] },
  "St. Lucia": { flag: "", ports: ["Castries","Cul-de-Sac","Pointe Seraphine"] },
  "St. Kitts & Nevis": { flag: "", ports: ["Basseterre"] },
  "St. Helena Island": { flag: "", ports: ["Jamestown"] },
  "Sri Lanka": { flag: "", ports: ["China Bay","Cod Bay","Colombo","Galle","Malay Cove","Trincomalee"] },
  "Sweden": { flag: "", ports: [
    "Ahus","Ala","Axelsvik Oil Terminal","Bado","Bollsta","Braviken","Brofjorden","Bulkhamnen","Djuro","Domsjo","Donso","Edstrandsbassangen",
    "Fredriksskans","Frihamnen","Froland","Gastgivarehagen","Gavle","Geffe","Goteborg","Gothenburg","Granudden","Hallstavik","Halmstad",
    "Hammarbyhamnen","Hargshamn","Harnosand","Helsingborg","Hudiksvall","Husum","Kage","Kalix","Kalmar","Karlsborg","Karlshall","Karlshamn",
    "Karlskrona","Karlstad","Karlsvik","Karskar","Kolo Harbour","Kubikenborg","Landskrona","Langror","Limhamn","Lomma","Loudden","Lugnvik",
    "Lulea","Lysekil","Malmo","Marstrand","Norrkoping","Nyhamn","Nykoping","Nynashamn","Ohmans","Ornskoldsvik","Orrskar","Ortviken","Oskarshamn",
    "Ostrand","Oxelosund","Oxhaga Harbour","Pampus Harbour","Paskallavik","Pitea","Ramshall","Ronneby","Ronnskar","Rya Harbour","Sandarne",
    "Skelleftea","Skeppsbron","Skoghall","Skredsvik","Skutskar","Slite","Soderhamn","Sodertalje & Sodertalje Canal","Solvesborg","Soraker",
    "Stadsgarden","Stenungsund","Stilleryd Harbour","Stockholm","Stockvik","Stormskar Oil Terminal","Stroemstad","Stugsund","Sundsvall",
    "Sutudden Harbour","Tallbacken","Trelleborg","Tunadalshamnen","Uddebo","Uddevalla","Umea","Utansjo","Vaja","Vallvik","Varberg","Vartahamnen",
    "Vasteras","Vastervik","Wallhamn"
  ]},
  "Syria": { flag: "", ports: ["Banias","Latakia","Tartous"] },
  "Tunisia": { flag: "", ports: ["Bizerte","Gabes","La Goulette","La Skhirra","Rades","Sfax","Tunis"] },
  "Trinidad & Tobago": { flag: "", ports: ["Brighton","Point Fortin","Port of Spain","Tembladora"] },
  "Togo": { flag: "", ports: ["Kpeme","Lome"] },
  "Thailand": { flag: "", ports: [
    "Bang Hua Sua","Bangkok","Chognonsri Marine Terminal","Klong Toey","Koh Si Chang Transhipment Area","Kohsichang TPP","Krung Thep",
    "Laem Chabang","Phuket","Sathupradit","Sattahip","Sima Seaport","Sriracha Harbour","Sriracha Oil Terminals"
  ]},
  "Tanzania": { flag: "", ports: ["Dar es Salaam","Mjimwema Oil Terminal","Mtwara","Tanga","Zanzibar City"] },
  "Taiwan": { flag: "", ports: [
    "Kaohsiung","Keelung","Sha Lung Oil Terminal","Ta-Lin-Pu Offshore Oil Terminal","Tanshui","Yun-An LNG Terminal"
  ]},
  "Türkiye": { flag: "", ports: [
    "Ambarli","Bandirma","Bodrum","Borusan","Canakkale","Derince","Edincik","Fethiye","Gemlik","Haydarpasa","Isdemir","Iskenderun","Istanbul",
    "Izmir","Izmit","Karakoy","Marmaris","Mersin","Nemrut/Aliaga","Pirs Ekindzhiler","Samsun","Sinop","Tutuncifilik","Yarımca"
  ]},
  "United Arab Emirates": { flag: "", ports: [
    "Ajman","Das Island","Dubai","Fateh Terminal","Jabal Ali","Port Khalid","Port Rashid","Fujairah","Sharjah"
  ]},
  "Ukraine": { flag: "", ports: [
    "Azovstal","Feodosia","Illyichevsk","Kerch","Kherson","Mariupol","Odessa","Reni","Sevastopol","Theodosia","Zhdanov"
  ]},
  "United Kingdom": { flag: "", ports: [
    "Aberdeen","Appledore","Arbroath","Ardrossan","Avonmouth","Ayr","Ballylumford","Barrow-in-Furness","Barry","Barton","Belfast","Bideford",
    "Bird Port","Birkenhead","Blyth","Bowling","Braefoot Bay","Brightlingsea","Bristol","Brixham","Brodick Harbour","Bromborough","Burntisland",
    "Burray","Cairnryan","Campbeltown","Canvey Island","Cardiff","Cattawater Harbour","Charlestown","Chatham Docks","Colchester","Coolkeragh",
    "Coryton","Cowes","Cromarty Firth","Dagenham","Dartmouth","Dover","Dover Strait","Dundee","Dunoon","Eastham","Eccles","Ellesmere Port",
    "Falmouth","Fawley","Felixstowe","Fingringhoe","Finnart","Fishguard","Flotta Terminal","Folkestone","Forth Ports","Fowey","Garston","Glasgow",
    "Gourock","Grangemouth","Granton","Gravesend","Grays","Great Yarmouth","Greenock","Greenwich","Grimsby","Hamble","Hartlepool","Harwich",
    "Heysham","Holm","Holyhead","Hound Point","Howden","Howdendyke","Hull","Immingham","Ince","Invergordon","Inverness","Ipswich","Irlam","Irvine",
    "Isle Of Grain","Killingholme","King’s Lynn","Kingsnorth","Kirkcaldy","Kirkwall","Lamlash Harbour","Lancaster","Largs","Larne","Leith","Lerwick",
    "Lisahally Port","Liverpool","London","Londonderry","Longhope","Lowestoft","Lydney","Lyness","Manchester","Manchester Ship Canal","Maydown",
    "Medway Ports","Methil","Middlesbrough","Milford Docks","Milford Haven","Mistley","Montrose","Neath","New Holland","Newcastle upon Tyne",
    "Newhaven","Newlyn","Nigg Oil Terminal","North Woolwich","Oakham Ness","Oban","Old Kilpatrick","Otterham","Par","Partington","Pembroke","Penryn",
    "Penzance","Peterhead Bay Harbour","Peterhead Harbours","Plymouth","Poole","Port Henry","Port Lamont","Port Talbot","Portree","Portsmouth",
    "Purfleet","Queenborough","Redcar","Ridham Dock","Rochester","Rosyth","Rothesay","Rowhedge","Runcorn","Salford","Salt Island","Saltburn",
    "Saltend","Scalloway","Scapa Flow","Scrabster","Seaham","Seal Sands","Sharpness and Gloucester","Shell Haven","Shoreham","Silvertown",
    "Southampton","St Mary’s (Scilly Islands)","Stanlow","Stornoway","Stranraer","Sullom Voe","Sunderland","Swansea","Teesport","Teignmouth",
    "Thamesport","Thetwall","Tilbury","Torbay Harbour","Torquay","Totnes","Tranmere Oil Terminal","Truro","Tyne","Warrington","Wemyss Bay",
    "Weston Point","Whitehaven","Wick","Wivenhoe","Workington"
  ]},
  "United States": { flag: "", ports: [
    "Aberdeen","Baltimore","Baton Rouge","Boston","Brunswick","Camden","Charleston","Chester","Chicago","Cleveland","Columbia","Corpus Christi",
    "Duluth-Superior","Dundalk","Dutch Harbor","East Bay","Eddystone","El Segundo Terminal","Elizabeth","Eufaula","Eureka","Everett","Everglades",
    "Fairport Harbor","Fall River","Ferndale","Fort Lauderdale","Fort Pierce","Freeport","Galena Park","Galveston","Geismar","Girard Point",
    "Grays Harbor","Greens Bayou","Greenwich Point","Gretna","Groton","Gulfport","Haines","Hampton Roads","Hawkins Point","Hercules",
    "Hillsborough Bay","Hilo","Honolulu","Hoquiam","Houston","Humboldt Bay","Jacintoport","Jacksonville","Jeffries Point","Juneau","Key West",
    "Kodiak","Lake Calumet Harbor","Lake Charles","Lemont","Locust Point","Long Beach","Los Angeles","Lummus Island","Manchester","March Point",
    "Marcus Hook","Mare Island","Marrero","Martinez","McDuffie Island","Melville","Meraux","Miami","Milwaukee","Mobile","Montgomery",
    "Morehead City","National City","Nederland","New Bedford","New Haven","New Jersey","New London","New Orleans","New York & New Jersey",
    "Newark","Newport (Rhode Island)","Newport News","Nikiski","Nome","Norfolk","North Kingstown","Northport","Northville","Oleum","Orange","Ozol",
    "Palm Beach","Panama City","Pasadena","Paulsboro","Penns Grove","Pennsauken","Pensacola","Perth Amboy","Philadelphia","Phoenix City",
    "Piney Point","Pittsburg","Port Arthur","Port Canaveral","Port Chester Harbor","Port Covington","Port Everglades","Port Huron","Port Isabel",
    "Port Jefferson","Port Manatee","Port Neches","Port Newark","Port Richmond","Port San Luis","Port St Joe","Port Sutton","Port Townsend",
    "Portland (Maine)","Portland (Oregon)","Portsmouth","Portsmouth (New Hampshire)","Providence","Rattlesnake","Revere","Richmond (Virginia)",
    "Riverhead Terminal","Rockport","Sabine","Salem","San Diego","San Francisco","San Pedro Harbor","Sandwich","Santa Barbara","Savannah",
    "Searsport","Seattle","Selby","Selma","Seward","Sitka","Skagway","Smith’s Bluff","South Locust Point","Sparrow’s Point","St Bernard Port",
    "St Petersburg","Stamford Harbor","Stockton","Superior","Tacoma","Tampa","Texas City","Texport","Three Mile Creek","Tiverton","Tuscaloosa",
    "Unalaska","Valdez","Vallejo","Vancouver","Weedon Island","West Wego","Whittier","Wilmington (Delaware)","Wilmington (North Carolina)",
    "Winterport","Yorktown"
  ]},
  "Uruguay" : { flag:"https://flagcdn.com/w320/uy.png", ports:["Montevideo", "Nueva Palmira","Paysandu"]},
  "Venezuela": {
    flag: "https://flagcdn.com/w320/ve.png",
    ports: [
      "Alcasa",
      "Amuay Bay",
      "Bachaquero",
      "Bajo Grande Refinery",
      "Borburata",
      "Caripito",
      "Cumarebo",
      "El Chaure",
      "El Palito",
      "El Tablizo",
      "Guaraguao",
      "Guaranao",
      "Guiria",
      "La Estacada",
      "La Guaira",
      "Las Piedras",
      "Los Cocos",
      "Maracaibo",
      "Moron",
      "Palua",
      "Pamatacual",
      "Paradero",
      "Pertigalete",
      "Puerto Cabello",
      "Puerto La Cruz",
      "Puerto Miranda",
      "Puerto Ordaz",
      "Punta Cardon",
      "Punta Cuchillo",
      "Punta de Palmas",
      "San Felix",
      "San Lorenzo",
      "Venterminales"
    ]
  },
  
  "Virgin Islands (US)": {
    flag: "https://flagcdn.com/w320/vi.png",
    ports: [
      "Charlotte Amalie",
      "Christiansted",
      "Frederiksted",
      "Hovic",
      "Limetree Bay",
      "Port Alucroix",
      "St Thomas",
      "Third Port"
    ]
  },
  "Vietnam": {
    flag: "https://flagcdn.com/w320/vn.png",
    ports: [
      "Ben Nghe",
      "Cho-Lon",
      "Danang",
      "Haiphong",
      "Ho Chi Minh City",
      "Nha Be",
      "Saigon"
    ]
  },
  "Yemen": {
    flag: "https://flagcdn.com/w320/ye.png",
    ports: [
      "Aden",
      "Hodeldah",
      "Khalf Harbour",
      "Little Aden",
      "Ma’alla Terminal",
      "Mokha",
      "Mukalla",
      "Ras Alkatheeb",
      "Saleef"
    ]
  },
  };

// ISO-2 map for the countries/regions you listed (FlagCDN wants lowercase ISO2)
const ISO2 = {
  // A
  "Antigua": "ag",
  "Angola": "ao",
  "Algeria": "dz",
  "Albania": "al",
  "Argentina": "ar",
  "Ascension Island": "sh",      // fallback to Saint Helena (parent)
  "Aruba": "aw",
  "Australia": "au",
  "Azores": "pt",                // fallback to Portugal (parent)

  // B
  "Bahamas": "bs",
  "Bahrain": "bh",
  "Bangladesh": "bd",
  "Barbados": "bb",
  "Belgium": "be",
  "Belize": "bz",
  "Benin": "bj",
  "Bermuda": "bm",
  "Brazil": "br",
  "Brunei Darussalam": "bn",
  "Bulgaria": "bg",

  // C
  "Cameroon Republic": "cm",     // Cameroon
  "Canada": "ca",
  "Cayman Islands": "ky",
  "Cape Verde Islands": "cv",    // Cabo Verde
  "Canary Islands": "es",        // fallback to Spain (parent)
  "Chile": "cl",
  "China": "cn",
  "Cocos Islands": "cc",
  "Christmas Island": "cx",
  "Colombia": "co",
  "Costa Rica": "cr",
  "Congo (Democratic Republic)": "cd",
  "Congo (Republic of Congo)": "cg",
  "Comoros": "km",
  "Croatia": "hr",
  "Cuba": "cu",
  "Cyprus": "cy",

  // D–F
  "Denmark": "dk",
  "Ecuador": "ec",
  "Dominican Republic": "do",
  "Dominica": "dm",
  "Djibouti": "dj",
  "Egypt": "eg",
  "Fiji": "fj",
  "Faroe Islands": "fo",
  "Falkland Islands": "fk",
  "Estonia": "ee",
  "Eritrea": "er",
  "Equatorial Guinea": "gq",
  "El Salvador": "sv",
  "Finland": "fi",
  "France": "fr",
  "French Polynesia": "pf",

  // G
  "Georgia": "ge",
  "Gambia": "gm",
  "Gabon": "ga",
  "Germany": "de",
  "Gibraltar": "gi",
  "Ghana": "gh",
  "Greece": "gr",
  "Guyana": "gy",
  "Guinea-Bissau": "gw",
  "Guinea": "gn",
  "Guatemala": "gt",
  "Guam": "gu",
  "Guadeloupe": "gp",
  "Grenada": "gd",
  "Greenland": "gl",
  "Honduras": "hn",
  "Haiti": "ht",
  "Hong Kong": "hk",
  "Iceland": "is",
  "India": "in",
  "Indonesia": "id",
  "Iran": "ir",
  "Iraq": "iq",
  "Ireland": "ie",
  "Israel": "il",
  "Isle of Man": "im",
  "Italy": "it",
  "Jamaica": "jm",
  "Ivory Coast": "ci",
  "Japan": "jp",
  "Kenya": "ke",
  "Jordan": "jo",
  "Kiribati": "ki",
  "North Korea": "kp",
  "South Korea": "kr",
  "Kuwait": "kw",
  "Latvia": "lv",
  "Lebanon": "lb",
  "Liberia": "lr",
  "Libya": "ly",
  "Madeira": "pt",
  "Madagascar": "mg",
  "Maldives": "ml",
  "Lithuania": "lt",
  "Malaysia": "my",
  "Mauritius": "mu",
  "Mauritania": "mr",
  "Martinique": "mq",
  "Malta": "mt",
  "Mexico": "mx",
  "Myanmar": "mm",
  "Mozambique": "mz",
  "Morocco": "ma",
  "Monaco": "mc",
  "Micronesia": "fm",
  "Nauru": "nr",
  "Namibia": "na",
  "Netherlands": "nl",
  "New Caledonia": "nc",
  "Netherlands Antilles": "nl", // deprecated (fallback to NL)
  "New Zealand": "nz",
  "Nigeria": "ng",
  "Nicaragua": "ni",
  "Norway": "no",
  "Papua New Guinea": "pg",
  "Panama": "pa",
  "Pakistan": "pk",
  "Oman": "om",
  "Peru": "pe",
  "Philippines": "ph",
  "Puerto Rico": "pr",
  "Portugal": "pt",
  "Poland": "pl",
  "Qatar": "qa",
  "Romania": "ro",
  "Reunion": "re",
  "Russia": "ru",
  "South Africa": "za",
  "Somalia": "so",
  "Solomon Islands": "sb",
  "Slovenia": "si",
  "Singapore": "sg",
  "Sierra Leone": "sl",
  "Seychelles": "sc",
  "Serbia & Montenegro": "rs", // fallback to Serbia
  "Senegal": "sn",
  "Saudi Arabia": "sa",
  "São Tomé and Príncipe": "st",
  "Samoa": "ws",
  "Spain": "es",
  "Suriname": "sr",
  "Sudan": "sd",
  "St. Vincent": "vc",
  "St. Lucia": "lc",
  "St. Kitts & Nevis": "kn",
  "St. Helena Island": "sh",
  "Sri Lanka": "lk",
  "Sweden": "se",
  "Syria": "sy",
  "Tunisia": "tn",
  "Trinidad & Tobago": "tt",
  "Togo": "tg",
  "Thailand": "th",
  "Tanzania": "tz",
  "Taiwan": "tw",
  "Turkey": "tr",
  "United Arab Emirates": "ae",
  "Ukraine": "ua",
  "United Kingdom": "gb",
  "United States": "us"
};

// Build a valid FlagCDN URL
const flagUrl = (iso2) => `https://flagcdn.com/w320/${iso2.toLowerCase()}.png`;

// Fill missing/empty flags safely (uses parent-country fallbacks above)
for (const [name, obj] of Object.entries(countriesWithPorts)) {
  if (!obj.flag) {
    const code = ISO2[name];
    obj.flag = code ? flagUrl(code) : ""; // keep empty if truly unknown
  }
}

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);

 const allCountries = Object.entries(countriesWithPorts).map(([name, v]) => ({
  value: name,
  label: name,
  flag: v.flag
}));

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [activeRegion, setActiveRegion] = useState(null); // clicked region
  const [hoveredRegion, setHoveredRegion] = useState(null); // hovered region
  const dropdownRef = useRef(null);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
        setActiveRegion(null);
        setHoveredRegion(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
const Spinner = () => (
  <svg
    className="animate-spin h-5 w-5 mr-2"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
  >
    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"/>
    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4A4 4 0 008 12H4z"/>
  </svg>
);

  return (
    <div className="bg-[#9ccee2] ">
      {user ? user.is_superuser ? <NewAdminNav /> : <Usernav /> : <NewHomeNav />}

      <section className="mt-14 ">
        <div className=" px-[30px] xm:px-[10px]   w-[100%] lg:w-[90%] m-auto ">
          {/* Links for selecting form type */}
          <div className="flex justify-center gap-8 lg:flex-wrap lg:gap-5 items-center">
            <button className="text-[#2e5775] text-2xl mb-3 font-bold">
              Register Ship For Charter
            </button>
          </div>

          {/* Conditional Form Rendering */}

          <Link to={"/regShip"} className="px-3  text-[#2e5775]">
            <i className="fa-solid fa-beat fa-arrow-left "></i> Back
          </Link>

          <form className="bg-white mt-2 rounded w-full">
  <div className="p-5">
    <h1 className="text-black font-bold text-xl">Register Ship For Charter</h1>
  </div>
  <hr className="text-gray-100 w-full" />

  {/* Vessel Type & Reference Id */}
  <div className="p-5 flex flex-col gap-5">
    <div className="flex items-center gap-4">
      <label htmlFor="VesselType" className="font-semibold w-[200px]">
        Vessel Type
      </label>
      <select
        value={vesselType}
        onChange={(e) => setvesselType(e.target.value)}
        className="flex-1 rounded border border-gray-400 p-2 text-[#d1a460]"
        id="VesselType"
      >
        <option hidden value="">
          -Select-
        </option>
        <option disabled value="">
          Categories
        </option>
        <option value="Barge">Barge</option>
        <option value="Bulk">Bulk</option>
        <option value="Cargo">Cargo</option>
        <option value="Container">Container</option>
        <option value="Fishing">Fishing</option>
        <option value="Multipurpose">Multipurpose</option>
        <option value="Passenger/Ferry">Passenger/Ferry</option>
        <option value="Reefer">Reefer</option>
        <option value="RoRo">RoRo</option>
        <option value="Tanker">Tanker</option>
        <option value="Dredger">Dredger</option>
        <option value="Floating Crane">Floating Crane</option>
        <option value="Floating Dock">Floating Dock</option>
        <option value="Landing Craft">Landing Craft</option>
        <option value="Yacht">Yacht</option>
        <option value="Tug Boat">Tug Boat</option>
        <option value="Supply Boat">Supply Boat</option>
        <option value="Crew Boat">Crew Boat</option>
        <option value="Other">Other</option>
      </select>
    </div>

    {generatedCode && (
      <div className="flex items-center gap-4">
        <label htmlFor="GeneratedCode" className="font-semibold w-[200px]">
          Reference Id
        </label>
        <input
          value={generatedCode}
          onChange={(e) => setGeneratedCode(e.target.value)}
          className="flex-1 rounded border border-gray-400 p-2 text-gray-500"
          id="GeneratedCode"
          disabled
        />
      </div>
    )}
  </div>

  {/* Open Area & DWT */}
  {/* Open Area (Country + Port selector) */}
<div className="flex items-center p-6 gap-4">
  <label htmlFor="OpenArea" className="font-semibold w-[200px]">
    Open Area
  </label>

  <div className="flex-1 relative" id="OpenArea">
    {/* Trigger */}
    <div
      className="w-full rounded border border-gray-400 cursor-pointer text-gray-600 p-2 bg-white flex justify-between items-center"
      onClick={() => setDropdownOpen((prev) => !prev)}
    >
      {selectedCountry && selectedPort
        ? `${selectedPort}, ${selectedCountry}  `
        : selectedCountry
        ? `${selectedCountry} — Select Port`
        : "-Open Area-"}
      <i className="fa-solid fa-chevron-down ml-2 text-sm"></i>
    </div>

    {/* Dropdown */}
    {dropdownOpen && (
      <div
        className="absolute top-full left-0 mt-1 shadow-md bg-white border rounded z-50
                   max-h-[360px] overflow-hidden flex"
        onMouseLeave={() => setDropdownOpen(false)}
      >
        {/* Left: Countries w/ hover */}
        <div className="w-64 max-h-[360px] overflow-y-auto">
          {/* Optional: search */}
          <div className="p-2 border-b">
            <input
              placeholder="Search country..."
              className="w-full p-2 border rounded text-sm"
              value={countryQuery}
              onChange={(e) => setCountryQuery(e.target.value)}
            />
          </div>

          {allCountries
            .filter(c =>
              !countryQuery?.trim()
                ? true
                : c.label.toLowerCase().includes(countryQuery.toLowerCase())
            )
            .map((country) => (
              <div
                key={country.value}
                className={`flex items-center gap-2 py-2 px-3 hover:bg-gray-100 cursor-pointer ${
                  hoverCountry === country.value ? "bg-gray-100" : ""
                }`}
                onMouseEnter={() => setHoverCountry(country.value)}
                onClick={() => {
                  // allow selecting country without port
                  setSelectedCountry(country.value);
                  setSelectedPort(""); // reset port
                }}
              >
                <img src={country.flag} alt="" className="w-5 h-5 rounded-sm" />
                <span className="truncate">{country.label}</span>
              </div>
            ))}
        </div>

        {/* Right: Ports for hovered/selected country */}
        <div className="w-80 border-l max-h-[360px] overflow-y-auto">
          <div className="p-2 border-b bg-gray-50 text-sm font-semibold">
            {hoverCountry || selectedCountry || "Ports"}
          </div>
          <div className="p-2">
            {(() => {
              const cName = hoverCountry || selectedCountry;
              const ports =
                cName && countriesWithPorts[cName]
                  ? countriesWithPorts[cName].ports
                  : [];

              if (!cName)
                return <div className="text-sm text-gray-500">Hover a country to see ports</div>;

              if (!ports?.length)
                return <div className="text-sm text-gray-500">No ports listed</div>;

              return ports.map((port) => (
                <div
                  key={port}
                  className="py-2 px-2 rounded hover:bg-gray-100 cursor-pointer text-sm"
                  onClick={() => {
                    setSelectedCountry(cName);
                    setSelectedPort(port);
                    setDropdownOpen(false);
                  }}
                >
                  {port}
                </div>
              ));
            })()}
          </div>
        </div>
      </div>
    )}
  </div>
</div>

 <div className="flex p-5 items-center gap-4">
      <label htmlFor="DWT" className="font-semibold w-[200px]">
        DWT
      </label>
      <input
        value={DWT}
        placeholder="Enter the Capacity"
        onChange={(e) => setDWT(e.target.value)}
        className="flex-1 rounded border border-gray-400 p-2 text-gray-500"
        id="DWT"
      />
    </div>


  {/* TC/VC & Year Built */}
  <div className="p-5 flex flex-col gap-5">
    <div className="flex items-center gap-4">
      <label className="font-semibold w-[200px]">TC/VC</label>
      <select
        value={TCVC}
        onChange={(e) => setTCVC(e.target.value)}
        className="flex-1 rounded border border-gray-400 p-2 text-gray-500"
      >
        <option value="" disabled>
          -Select-
        </option>
        <option value="Time Charter">Time Charter</option>
        <option value="Voyage Charter">Voyage Charter</option>
      </select>
    </div>

    <div className="flex items-center gap-4">
      <label htmlFor="YearBuilt" className="font-semibold w-[200px]">
        Year Built
      </label>
      <input
        value={YearBuilt}
        placeholder="Enter Built Year"
        onChange={(e) => setYearBuilt(e.target.value)}
        className="flex-1 rounded border border-gray-400 p-2 text-gray-500"
        id="YearBuilt"
      />
    </div>
  </div>

  {/* Lychan */}
  <div className="p-5 flex flex-col gap-5">
    <div className="flex items-center gap-4">
      <label htmlFor="Lychan" className="font-semibold w-[200px]">
        Lychan
      </label>
      <input
        value={Lychan}
        placeholder="Enter Lychan"
        onChange={(e) => setLychan(e.target.value)}
        className="flex-1 rounded border border-gray-400 p-2 text-gray-500"
        id="Lychan"
      />
    </div>
  </div>

  {/* Ship Owner Name & Company */}
  <div className="p-5 flex flex-col gap-5">
    <div className="flex items-center gap-4">
      <label htmlFor="OwnerName" className="font-semibold w-[200px]">
        Ship Owner Name
      </label>
      <input
        value={name}
        placeholder="Enter Owner Name"
        onChange={(e) => setName(e.target.value)}
        className="flex-1 rounded border border-gray-400 p-2 text-gray-500"
        id="OwnerName"
      />
    </div>

    <div className="flex items-center gap-4">
      <label htmlFor="Company" className="font-semibold w-[200px]">
        Ship Owner Company
      </label>
      <input
        value={Company}
        placeholder="Enter Company Name"
        onChange={(e) => setCompany(e.target.value)}
        className="flex-1 rounded border border-gray-400 p-2 text-gray-500"
        id="Company"
      />
    </div>

    <div className="flex items-center gap-4">
      <label htmlFor="CompanyAddress" className="font-semibold w-[200px]">
        Company Address
      </label>
      <input
        value={CompanyAddress}
        placeholder="Enter Company Address"
        onChange={(e) => setCompanyAddress(e.target.value)}
        className="flex-1 rounded border border-gray-400 p-2 text-gray-500"
        id="CompanyAddress"
      />
    </div>
  </div>

  {/* Email & Mobile */}
  <div className="p-5 flex flex-col gap-5">
    <div className="flex items-center gap-4">
      <label htmlFor="Email" className="font-semibold w-[200px]">
        Email
      </label>
      <input
        value={Email}
        placeholder="Enter your Email"
        onChange={(e) => setEmail(e.target.value)}
        className="flex-1 rounded border border-gray-400 p-2 text-gray-500"
        id="Email"
      />
    </div>

    <div className="flex items-center gap-4">
      <label htmlFor="MobileNO" className="font-semibold w-[200px]">
        Mobile No
      </label>
      <input
        value={MobileNO}
        placeholder="Enter your Mobile No"
        onChange={(e) => setMobileNO(e.target.value)}
        className="flex-1 rounded border border-gray-400 p-2 text-gray-500"
        id="MobileNO"
      />
    </div>
  </div>

  {user?.is_superuser && (
      <div className="flex p-5 items-center gap-3">
      <label htmlFor="URL" className="font-semibold w-[200px]">
       URL
      </label>
      <input
        value={Url}
        onChange={(e) => setUrl(e.target.value)}
        className="flex-1 rounded border border-gray-400 text-gray-500 p-2"
        id="Url"
        placeholder="Enter Your Url"
      />
    </div>
    )}

  {/* Additional Info */}
  <div className="p-5 flex items-start gap-4">
    <label htmlFor="BriefDescription" className="font-semibold w-[200px]">
      Additional Information
    </label>
    <textarea
      placeholder="More info..."
      value={BriefDescription}
      onChange={(e) => setBriefDescription(e.target.value)}
      rows={5}
      className="flex-1 rounded border border-gray-400 p-2 text-gray-500"
      id="BriefDescription"
    ></textarea>
  </div>

  {/* Submit */}
  <hr className="text-gray-500 w-full" />
  <div className="p-4">
    <button
  type="submit"
  onClick={(e) => handleSubmitCharter(e)}
  disabled={loading} // prevent double submits
  aria-busy={loading}
  className={`bg-green-600 hover:bg-green-500 text-white px-5 py-2 rounded w-full
              flex items-center justify-center
              ${loading ? "opacity-80 cursor-not-allowed" : ""}`}
>
  {loading ? (
    <>
      <Spinner />
    </>
  ) : (
    "Submit"
  )}
</button>

  </div>
</form>

        </div>

        {otpModalOpen && (
  <div className="fixed inset-0 z-[9999] bg-black/40 flex items-center justify-center">
    <div className="bg-white w-full max-w-md rounded-2xl shadow-xl p-6">
      <h3 className="text-lg font-semibold mb-2">Verify Your Email</h3>
      <p className="text-sm text-gray-600 mb-4">
        We’ve sent a 6-digit code to <span className="font-medium">{otpEmail}</span>. Enter it below to continue.
      </p>

      <input
        inputMode="numeric"
        maxLength={6}
        value={otpCode}
        onChange={(e) => setOtpCode(e.target.value.replace(/\D/g, "").slice(0, 6))}
        placeholder="Enter 6-digit OTP"
        className="w-full border rounded p-3 tracking-widest text-center text-lg"
      />

      <div className="flex items-center justify-between mt-4">
        <button
          className="text-sm text-gray-600 hover:underline"
          onClick={() => setOtpModalOpen(false)}
        >
          Cancel
        </button>

        <div className="flex items-center gap-3">
          <button
            disabled={otpSending || otpTimer > 0}
            onClick={() => requestEmailOtp(otpEmail)}
            className={`text-sm ${otpTimer ? "text-gray-400" : "text-blue-600 hover:underline"}`}
          >
            {otpTimer ? `Resend in ${otpTimer}s` : "Resend Code"}
          </button>

          <button
            disabled={!isSixDigits(otpCode) || otpVerifying}
            onClick={async () => {
              setOtpVerifying(true);
              try {
                // verify first
                await axios.post(`${config.base_url}/api/HappyMarineShipping/auth/verify-email-otp/`, {
                  email: otpEmail,
                  otp_code: otpCode,
                });
                // success — close modal and submit the original form with otp_code
                setOtpModalOpen(false);
                await submitCharterToServer();
              } catch (err) {
                const msg = err?.response?.data?.message || "Invalid/expired OTP";
                toast.error(msg);
              } finally {
                setOtpVerifying(false);
              }
            }}
            className="bg-green-600 hover:bg-green-500 text-white px-4 py-2 rounded disabled:opacity-50"
          >
            {otpVerifying ? "Verifying..." : "Verify & Submit"}
          </button>
        </div>
      </div>
    </div>
  </div>
)}

      </section>

      {/* Go to Top Button */}
      {isScrolled && (
        <div
          className="fixed bottom-16 right-8 z-50 " // Ensure it's in the right position with high z-index
        >
          <div
            className="back-to-top px-4 hover:bg-[#615d91]"
            onClick={scrollToTop}
          >
            <i className="fa-solid fa-arrow-up text-2xl"></i>
          </div>
        </div>
      )}

      <NewFooter />
    </div>
  );
}
